import ImmutableModel from './immutable.model';

/**
 * A data type for results returned from the backend, for easy indexing and iteration.
 */
class ResourceCollection extends ImmutableModel {
  constructor(objs) {
    super();

    /**
     * @type {Array.<ImmutableModel>}
     */
    this.list = objs;

    /**
     * @type {Object.<number, ImmutableModel>}
     */
    this.dict = ResourceCollection._list2dict(objs);
  }

  copy() {
    return new ResourceCollection(this.list);
  }

  // Convert list of ImmutableModels to dictionary based on 'id'
  static _list2dict(data) {
    return data.reduce((acc, model) => {
      acc[model.id] = model;
      return acc;
    }, {});
  }
}

export default ResourceCollection;
